import { render, staticRenderFns } from "./appService.vue?vue&type=template&id=513e5b86&scoped=true"
import script from "./appService.vue?vue&type=script&lang=js"
export * from "./appService.vue?vue&type=script&lang=js"
import style0 from "./appService.vue?vue&type=style&index=0&id=513e5b86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e55c6b833ee07bd5ead5f0ade73438ed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e5b86",
  null
  
)

export default component.exports